import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const simoSubs = resourceReducer('simoSubs', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default simoSubs;

export const getAllSimoSubs = (state, page = 1) =>
  getResources(state, `page${page}`);
export const getSimoSub = (state, id) => state.resources[id];
export const getSimoSubNotFoundFromFind = (state) =>
  Boolean(
    state.requests &&
      state.requests.find &&
      state.requests.find.statusCode === 404,
  );
export const getCreatedSimoSub = (state) =>
  state.requests.create &&
  state.requests.create.status === 'SUCCEEDED' &&
  state.resources[state.requests.create.ids[0]];
export const getAllSimoInitialsSubs = (state) =>
  getResources(state, `allSimoInitialsSubs`);
export const getAllSimoInitialsSubsStatus = (state) =>
  state.requests.fetchAllSimoInitialsSubs &&
  state.requests.fetchAllSimoInitialsSubs.status;
export const getUserSimoSubs = (state) => getResources(state, 'userSubs');
export const getAllUserSimoSubs = (state, userId) =>
  getResources(state, `userSimoSubs${userId}`);
export const getSearchSimoSubs = (state, page = 1) =>
  getResources(state, `searchPage${page}`);
export const getSimoActivationResponse = (state, subId) =>
  state.meta[subId] && state.meta[subId].activation;
export const getSimoDeviceDetails = (state) =>
  state.requests.updateDevice && state.requests.updateDevice.details;
export const getSubUpcomingPlan = (state, subId) =>
  state.meta[subId] && state.meta[subId].upcomingPlan;
export const getFilteredSimoSubs = (state, filter, page) =>
  getResources(state, `${filter}Subs${page}`);
